import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface FooterLink {
  id: number;
  label: string;
  href: string;
}

const creatorLinks: FooterLink[] = [
  { id: 1, label: "Apply Now", href: "#" },
  { id: 2, label: "Creator Dashboard", href: "#" },
  { id: 3, label: "Resources", href: "#" },
  { id: 4, label: "Success Stories", href: "#" }
];

const supportLinks: FooterLink[] = [
  { id: 1, label: "Help Center", href: "#" },
  { id: 2, label: "Creator Guidelines", href: "#" },
  { id: 3, label: "Contact Support", href: "#" },
  { id: 4, label: "Community Forum", href: "#" }
];

const legalLinks: FooterLink[] = [
  { id: 1, label: "Terms of Service", href: "#" },
  { id: 2, label: "Privacy Policy", href: "#" },
  { id: 3, label: "Content Policy", href: "#" },
  { id: 4, label: "Copyright", href: "#" }
];

interface SocialLink {
  id: number;
  icon: string;
  label: string;
  href: string;
}

const socialLinks: SocialLink[] = [
  { id: 1, icon: "facebook", label: "Facebook", href: "#" },
  { id: 2, icon: "twitter", label: "Twitter", href: "#" },
  { id: 3, icon: "instagram", label: "Instagram", href: "#" },
  { id: 4, icon: "youtube", label: "YouTube", href: "#" }
];

export default function FooterSection() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <Link href="/homepage" className="flex items-center space-x-2 mb-4 group">
              <div className="relative w-10 h-10 flex items-center justify-center bg-primary rounded-full transition-transform duration-300 group-hover:scale-110">
                <svg
                  viewBox="0 0 40 40"
                  className="w-8 h-8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="20" cy="20" r="18" fill="white" opacity="0.2" />
                  <text
                    x="20"
                    y="26"
                    fontSize="16"
                    fontWeight="700"
                    fill="white"
                    textAnchor="middle"
                    fontFamily="Poppins, sans-serif"
                  >
                    SN
                  </text>
                </svg>
              </div>
              <span className="text-xl font-heading font-bold text-primary">
                StoryNest-FM
              </span>
            </Link>
            <p className="text-text-secondary text-sm leading-relaxed mb-4">
              Empowering creators to share their stories and build thriving audio content careers across India.
            </p>
            <div className="flex items-center space-x-3">
              {socialLinks.map((social) => (
                <a
                  key={social.id}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 bg-muted rounded-full flex items-center justify-center text-text-secondary hover:bg-primary hover:text-primary-foreground transition-all duration-300"
                >
                  <Icon name="ShareIcon" size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-text-primary mb-4">
              For Creators
            </h3>
            <ul className="space-y-2">
              {creatorLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.href}
                    className="text-text-secondary hover:text-primary transition-colors duration-300 text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-text-primary mb-4">
              Support
            </h3>
            <ul className="space-y-2">
              {supportLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.href}
                    className="text-text-secondary hover:text-primary transition-colors duration-300 text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-text-primary mb-4">
              Legal
            </h3>
            <ul className="space-y-2">
              {legalLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.href}
                    className="text-text-secondary hover:text-primary transition-colors duration-300 text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-text-secondary text-sm">
              © {currentYear} StoryNest-FM. All rights reserved.
            </p>
            <div className="flex items-center space-x-4 text-sm text-text-secondary">
              <span>Made with</span>
              <Icon name="HeartIcon" size={16} className="text-error" />
              <span>in India</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}